import { Button, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import DeviceControlImage from '../../../common-images/app-logo/customer-images/DeviceControlImage'
import { RootState } from '../../../redux/deviceStatistics/types'

const GroupSettingBtn = () => {
  const defaultUserData = useSelector((state: RootState) => state.user)
  const navigate = useNavigate()
  const location = useLocation()

  const isActive =
    location.pathname.includes('/groups') ||
    location.pathname.includes('/batch') ||
    location.pathname.includes('/Agent') ||
    location.pathname.includes('/legacy')

  return (
    <React.Fragment>
      <Tooltip
        disableInteractive
        slotProps={{
          tooltip: {
            sx: {
              bgcolor: '#707e8c'
            }
          }
        }}
        title={<Typography>Administration</Typography>}
      >
        <Button
          className={`reload-btn ${isActive ? 'mx-3' : 'me-2'}`}
          onClick={() => navigate(defaultUserData?.isPlatformSupportAdmin ? '/Agent' : '/groups')}
          data-testid='testid_group_btn'
        >
          <DeviceControlImage />
        </Button>
      </Tooltip>
    </React.Fragment>
  )
}

export default GroupSettingBtn
